<template>
    <div class="template-base">
        <Header Title="Batch Pin Codes" :iconPath="'/images/icons/pincode.png'" class="div-header" />
        <div class="menu-bar">
            <Button class="x-smaller-button" :buttonModel="btnExit"></Button>
            <Button class="x-smaller-button" :buttonModel="btnGenerate" @click="generatePins"></Button>
        </div>
        <div class="select-button-container-preferences div-body" v-if="!fetchData">
            <div class="setting-item">
                <div class="setting-header">                                                            
                    <div style="display:flex;flex-direction:column">
                        <div class="setting-input-container">
                            <span class="setting-name setting-col">Title</span>
                            <textarea class="setting-input-item" name="message" rows="10" cols="30" v-model="title" title="Message to display on receipt" aria-label="Message to display on receipt"></textarea>
                        </div>

                        <div class="setting-input-container">
                            <span class="setting-name setting-col">Number of Balls</span>
                            <input class="setting-input-item administrator-input-item-numeric" type="number" min="1" max="1000" step="1" v-model.number="balls" title="Number of balls to dispense" aria-label="Number of balls to dispense" />
                        </div>

                        <div class="setting-input-container">
                            <span class="setting-name setting-col">Number of Pin Codes</span>
                            <input class="setting-input-item administrator-input-item-numeric" type="number" min="1" max="200" step="1" v-model.number="numberOfPincodes" title="Number of pin codes to print on receipt" aria-label="Number of pin codes to print on receipt" />
                        </div>

                        <div class="setting-input-container">
                            <span class="setting-name setting-col">Pin Expiration Days <span style="font-size: 10pt;">(max {{ maxDays}})</span> </span>
                            <input class="setting-input-item administrator-input-item-numeric" type="number" min="0" :max="maxDays" step="1" v-model.number="expirationDays" title="Number of days the pin codes are valid" aria-label="Number of days the pin codes are valid"/>
                            <div></div>
                        </div>
                        <div class="setting-input-container">
                            <span class="setting-name setting-col">
                                <input type="checkbox" id="chkEndOfDay" v-model="endOfDay" title="Option to expire pin codes at tne of last day" aria-label="Option to expire pin codes at tne of last day" />
                                <label for="chkEndOfDay" title="Option to expire pin codes at tne of last day" aria-label="Option to expire pin codes at tne of last day">End Of Day</label>
                            </span>
                        </div>
                        <div class="setting-input-container">
                            <span class="setting-name setting-col">
                                <input type="checkbox" id="chkPagePerPin" v-model="pagePerPin" title="Option to print pin codes on separate page" aria-label="Option to print pin codes on separate page"/>
                                <label for="chkPagePerPin"  title="Option to print pin codes on separate page" aria-label="Option to print pin codes on separate page">Separate page per pin</label>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <iframe ref="refPrintFrame" src="" frameborder="0" width="0px" height="0px" ></iframe>
    </div>    
</template>

<script>
import Header from "@/views/components/Shared/Header.vue";

import Button from "@/views/components/Shared/Button";
import ButtonModel from "@/common/models/ButtonModel";

import apiPincode from "@/api/apiPincode";
import apiSettings from "@/api/apiSettings";
import { getCurrentInstance, ref, onMounted } from "@vue/runtime-core";
// import Helper from "@/common/helper";

export default {
    components: {
        Header,
        Button
    },
    setup() {
        const btnExit = ButtonModel.CreateRoute("", "Home");
        btnExit.iconPath = "/images/icons/exit.png";
        btnExit.title = "Back to Main Page";

        const btnGenerate = ButtonModel.CreateClick("");
        btnGenerate.iconPath = "/images/icons/print.png"
        btnGenerate.title = "Generate pin codes..."   

        const emitter = getCurrentInstance().appContext.app.config.globalProperties.emitter;

        const title = ref("Batch Pin Codes");
        const balls = ref(10);
        const numberOfPincodes = ref(3);
        const expirationDays = ref(1);
        const endOfDay = ref(false);
        const pagePerPin = ref(false);
        const fetchData = ref(false);
        const refPrintFrame = ref(null)
        const maxDays = ref(40)


        onMounted(() => {
            getData();
        });


        const getData = async () => {
            try {
                emitter.emit("server-call-start", "Loading...");
                fetchData.value = true;
                const pincodeSettings = await apiSettings.getPinCode();
                if (pincodeSettings.pincodeDigits == 6) {
                    maxDays.value = 90
                } else if (pincodeSettings.pincodeDigits == 5) {
                    maxDays.value = 60
                } else {
                    maxDays.value = 30
                }
            } catch (err) {
                console.log("ERROR:", err);
                emitter.emit("show-alert", ["Error loading data", err]);
            }
            emitter.emit("server-call-stop");
            fetchData.value = false;
        };        


        const generatePins = async () => {
            try {
                emitter.emit("server-call-start", "Generating pin codes...");                
                var batchId = await apiPincode.generateBatch(title.value, balls.value, numberOfPincodes.value, expirationDays.value, endOfDay.value);                                
                refPrintFrame.value.src = `pin-ticket-batch.html?pagePerPin=${pagePerPin.value}&batchId=${encodeURIComponent(batchId)}`;
            } catch (err) {
                console.log("ERROR:", err);
                emitter.emit("show-alert", ["Error generating pin codes", err]);
            }
            emitter.emit("server-call-stop");
        };

        return {
            btnExit,
            btnGenerate,
            generatePins,
            title,
            balls,
            numberOfPincodes,
            expirationDays,
            endOfDay,
            pagePerPin,
            refPrintFrame,
            maxDays
        };
    }
};
</script>

<style scoped>
.setting-col {
    margin-right: 30px;
}
</style>
